<div
  class="photo-item"
  [class]="getClass()"
  (mouseenter)="showCustomTooltip()"
  (mouseleave)="hideCustomTooltip()"
  (click)="!isPossibleToEdit() ? handleValueClick(value) : null"
>
  <div class="photo-item-wrapper">
    @if (value) {
      <img
        width="40"
        height="40"
        alt="Фото"
        class="photo-item-img"
        [src]="value"
      />
    } @else {
      <img
        class="photo-item-img"
        src="/assets/images/fallback-image.svg"
        width="40"
        height="40"
        alt=""
      />
    }
  </div>

  @if (isImageAvailable() && isCustomTooltipShowed()) {
    <div
      class="photo-item-custom-tooltip none-pointer-events"
      [class]="tooltipPosition()"
      @smoothShowHideHeight
    >
      <img
        class="photo-item-preview-img"
        [src]="value"
        [style.width.px]="previewWidth"
        [style.height.px]="previewHeight"
        alt=""
      />
    </div>
  }
</div>
